import { ImpactType, TileSource, TileVariant } from '..';
import { PublicProjectSummary } from '../projects';
import { dateParser } from '../utils';

export type HabitatRestorationType = {
  _id: string;
  createdAt: string;
  impactType: ImpactType;
  invoiceId?: string;
  isPending?: boolean;
  isMocked?: boolean;
  name?: string;
  numberOfMeters: number;
  projectId: number;
  projectTitle?: string;
  variant: TileVariant;
  source: TileSource;
  groupId?: number;
};

export class HabitatRestoration {
  _id: string;
  createdAt: Date;
  impactType: ImpactType;
  isPending?: boolean;
  invoiceId?: string;
  isMocked?: boolean;
  name?: string;
  numberOfMeters: number;
  project?: PublicProjectSummary;
  projectId: number;
  projectTitle?: string;
  variant: TileVariant;
  source: TileSource;
  groupId?: number;

  constructor(restoration: HabitatRestorationType, project?: PublicProjectSummary) {
    this._id = restoration._id;
    this.createdAt = dateParser(restoration.createdAt);
    this.impactType = ImpactType.HABITAT_RESTORATION;
    this.invoiceId = restoration.invoiceId;
    this.isMocked = restoration.isMocked == true;
    this.isPending = restoration.isPending == true;
    this.name = restoration.name;
    this.numberOfMeters = restoration.numberOfMeters;
    this.project = project;
    this.projectId = restoration.projectId;
    this.projectTitle = restoration.projectTitle;
    this.variant = restoration.variant;
    this.source = restoration.source;
    this.groupId = restoration.groupId;
  }
}
